import {
    Grid,
    TextField } from "../ui";
import useUiController from "../global/hooks/useUiController";
import SnpBaseLayout from "../global/SnpBaseLayout";
import {
  CART_INITIAL_STATE,
  CartDets,
  GET_CATEOGORY_DATA,
  GET_CONVERSIONTYPE_DATA,
  getPreUrlAccordingToCart,
  INITIAL_PAGEMODEL,
  isEmpty,
  isRoleAllowed,
  local_test_url,
  SUCCESS,
  ROLE_CREATE,
  INVSTOCKMGMT,
  FOODITEMPRODUCTMGMT
} from "../../constants/constant";
import EnterButton from "../global/EnterButton";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import CustomDataGrid from "../global/CustomDataGrid";
import SnpButton from "../global/SnpButton";
import { snpAxios } from "../global/api";
import {
    INITIAL_CATEOGORY_ITEM, INITIAL_COLOR_MODEL, INITIAL_CONVERSION_SINGLE_DATA, INITIAL_GOLD_INVENTORY_FORM, INITIAL_INVENTORY_DETAILS,
    INITIAL_KARAT_INFO,
    INITIAL_PRODUCT_INFO
} from "./productConstant";
import ImageNotSupportedIcon from '../ui/icons/ImageNotSupported';

const ShowProduct = () => {

    const {
        loader,
        setLoader,
        snackbarConfig,
        closeSnackbar,
        dialogConfig,
        showDialog,
        closeDialog,
    } = useUiController();

    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const navigate = useNavigate();

    const [paginationModel, setPaginationModel] = useState(INITIAL_PAGEMODEL);
    const [productData, setProductData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [conversionTypeData, setConversionTypeData] = useState([]);

    const columns = [
        {
            field: "edit",
            headerName: "",
            width: 75,
            renderCell: (cellValues) => {
                return (
                    <SnpButton variant="contained"
                        mbgcolor="#538796"
                        mpadding="1px"
                        onPointerDown={() => openProductEntry(cellValues.row)}
                    >Edit</SnpButton>
                );
            }
        },
        { field: 'hsnCode', headerName: 'Hsn Code', width: 200 },
        {
            field: 'catgName', headerName: 'Category', width: 130, valueGetter: (params) => params.row.catgName, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        { field: 'inventoryTypeStr', headerName: 'Type', width: 140 },
        {
            field: 'prdName', headerName: 'Item', width: 150, valueGetter: (params) => params.row.prdName, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'brandName', headerName: 'Brand', width: 150, valueGetter: (params) => params.row.brandName, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'itemStatusStr', headerName: 'Status', width: 120, valueGetter: (params) => params.row.itemStatusStr, renderCell: (params) => (
                <span style={{ color: params.value === 'Active' ? '#0f633b' : "#7a1904" }}>{params.value}</span>
            ),
        }
    ];

    const columns_gold = [
        {
            field: "edit",
            headerName: "",
            width: 75,
            renderCell: (cellValues) => {
                return (
                    <SnpButton variant="contained"
                        mbgcolor="#538796"
                        mpadding="1px"
                        onPointerDown={() => openProductEntry(cellValues.row)}
                    >Edit</SnpButton>
                );
            }
        },
        {
            field: "productImage",
            headerName: "Icon",
            width: 100,
            renderCell: (rowData) => (
                <div>
                    {
                        isEmpty(rowData.row.image) ?
                            <ImageNotSupportedIcon style={{ height: "80px", width: "80px", borderRadius: "20%" }} /> : <img
                                alt=""
                                style={{ height: "80px", width: "80px", borderRadius: "20%" }}
                                src={rowData.row.image && storeApiUrl.BACKEND_BASE_URL + "files/" + rowData.row.image}
                            ></img>
                    }

                </div>
            ),
        },
        {
            field: 'catgName', headerName: 'Category', width: 130, valueGetter: (params) => params.row.catgName, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'articleNumber', headerName: 'Article No.', width: 130, valueGetter: (params) => params.row.articleNumber, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'name', headerName: 'Item', width: 150, valueGetter: (params) => params.row.name, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'brandName', headerName: 'Brand', width: 150, valueGetter: (params) => params.row.brandName, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'details', headerName: 'Karat Info', width: 150, valueGetter: (params) => params.row.karatInfo.details, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'itemStatusStr', headerName: 'Status', width: 120, valueGetter: (params) => params.row.itemStatusStr, renderCell: (params) => (
                <span style={{ color: params.value === 'Active' ? '#0f633b' : "#7a1904" }}>{params.value}</span>
            ),
        }
    ];

    const getProductDetails = async (mStock = "", optPage = 0, optTotal = 10) => {
        try {
            setLoader(true);
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}show-user-product-data-v2?token=${CART_INITIAL_STATE.apiToken}&shopHash=${storeActiveShopHash.id}&stock=${mStock}&page=${optPage}&total=${optTotal}`;
            const response = await snpAxios.get(cartUrl);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setProductData(payLoad.value_2);
                setPaginationModel(prev => ({
                    ...prev,
                    page: optPage,
                    pageSize: optTotal,
                    rowCount: payLoad.totalRecords,
                }));
            }
            setLoader(false);
        } catch (error) {
            console.error("getProductDetails", mStock, optPage, optTotal, error);
            setLoader(false);
        }
    };


    const getGoldInventory = async (mStock = "", optPage = 0, optTotal = 10) => {
        try {
            setLoader(true);
            //const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-gold-inventory`;
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-gold-inventory?token=${CART_INITIAL_STATE.apiToken}&shopHash=${storeActiveShopHash.id}&stock=${mStock}&page=${optPage}&total=${optTotal}`;
            const response = await snpAxios.get(cartUrl);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setProductData(payLoad.fullData);
                setPaginationModel(prev => ({
                    ...prev,
                    page: optPage,
                    pageSize: optTotal,
                    rowCount: payLoad.totalRecords,
                }));
            }
            setLoader(false);
        } catch (error) {
            console.error("getGoldInventory", mStock, optPage, optTotal, error);
            setLoader(false);
        }
    };

    const baseProductSearch = async (mStock = "", optPage = 0, optTotal = 10) => {
        if (storeActiveShopHash.cartType === CartDets.Gold) {
            await getGoldInventory(mStock, optPage, optTotal);
        } else {
            await getProductDetails(mStock, optPage, optTotal);
        }
    }

    const getCateogoryDetails = async () => {
        try {
            const catgUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${GET_CATEOGORY_DATA}`;
            const data = {
                jcJson: {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    shopHash: storeActiveShopHash.id,
                }
            };
            const response = await snpAxios.post(catgUrl, data);
            if (response.data.status === SUCCESS) {
                const resp = response.data.jcJson.value_2.map((catg) => {
                    const catgName = catg.details
                    const catgId = catg.id
                    return { catgName, catgId }
                })
                setCategoryData(resp);
            }
        } catch (error) {
            console.error("getCateogoryDetails", error);
        }
    };

    const getConversionData = async () => {
        try {
            const catgUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${GET_CONVERSIONTYPE_DATA}`;
            const data = {
                jcJson: {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    shopHash: storeActiveShopHash.id,
                    createNew: true,
                }
            };
            const response = await snpAxios.post(catgUrl, data);
            if (response.data.status === SUCCESS) {
                setConversionTypeData(response.data.jcJson.value_2);
            }
        } catch (error) {
            console.error("getConversionData", error);
        }
    };

    const showSnpDialogForShowStatus = (msg, onClose = () => { }) => {
        showDialog({
            ...dialogConfig,
            negativeReq: true,
            negativeAction: "Ok!", subTitle: msg,
            handleClose: onClose,
        });
    };

    const openProductEntry = (row) => {
        if (storeActiveShopHash.cartType === CartDets.Gold) {
            const state = {
                selectedCategory: row ? { catgId: row.catgId, catgName: row.catgName }
                    : INITIAL_CATEOGORY_ITEM,
                productInfo: row ? {
                    ...row,
                } : INITIAL_GOLD_INVENTORY_FORM,
                conversionSingleData: row ? { id: row.cnvId, cnvDetails: row.cnvDetails } : INITIAL_CONVERSION_SINGLE_DATA,
                karatInfo: row?.karatInfo ?? INITIAL_KARAT_INFO,
                categoryData: categoryData,
                isEditProduct: row ? true : false,
                conversionTypeData: conversionTypeData,
            }
            navigate("/dashboard/productentry", { state: state });
        } else {
            const state = {
                selectedCategory: row ? { catgId: row.catgId, inventoryType: row.inventoryType, catgName: row.catgName }
                    : INITIAL_CATEOGORY_ITEM,
                productInfo: row ? {
                    prdId: row.prdId, prdName: row.prdName,
                    brandName: row.brandName, hsnCode: row.hsnCode, rack_no: row.rack_no,
                    composition: row.composition || [], stockUsage: row.stockUsage || [],
                    stockSideEffects: row.stockSideEffects || [], stockStorage: row.stockStorage,
                    itemStatus: row.itemStatus, aboutItem: row.aboutItem,
                } : INITIAL_PRODUCT_INFO,
                inventoryDetails: row ? {
                    id: row.id, sizeType: row.sizeType,
                    personType: row.personType, itemStatus: row.invStatus,
                    productImage: row.productImage || [], allowedDelete: row.allowedDelete || false,
                    condition: row.condition, caseSize: row.caseSize, lugWidth: row.lugWidth,
                    jewels: row.jewels, caseMetal: row.caseMetal,
                    waterResistance: row.waterResistance, movementType: row.movementType,
                } : INITIAL_INVENTORY_DETAILS,
                color: row ? { colorId: row.colorId, colorDetails: row.colorDetails } : INITIAL_COLOR_MODEL,
                dialColor: row ? { colorId: row.dialColorId, colorDetails: row.dialColorDetails } : INITIAL_COLOR_MODEL,
                conversionSingleData: row ? { id: row.cnvId, cnvDetails: row.cnvDetails } : INITIAL_CONVERSION_SINGLE_DATA,
                listItemSuggestion: row ? row.listItemSuggestion || [] : [],
                categoryData: categoryData,
                isEditProduct: row ? true : false,
                conversionTypeData: conversionTypeData,
            }
            navigate("/dashboard/productentry", { state: state });
        }
    };

    const renderShowProduct = () => {
        return (
            <Grid container spacing={1}>
                <Grid item xs={12} md={6} sm={6} lg={6}>
                    <div style={{ padding: 10 }}>
                        <EnterButton
                            variant="contained"
                            color="primary"
                            style={{ float: "right" }}
                            onPointerDown={() => {
                                if (isRoleAllowed([INVSTOCKMGMT, FOODITEMPRODUCTMGMT], ROLE_CREATE)) {
                                    openProductEntry(null);
                                } else {
                                    showSnpDialogForShowStatus("You Are not allowed to Add/Update Stock Details.Contact the Owner", closeDialog);
                                }
                            }}>
                            Add New Product
                        </EnterButton>
                    </div>
                </Grid>
                <Grid item xs={12} md={6} sm={6} lg={6}>
                    <TextField
                        required
                        id="searchProduct"
                        label="Search Product"
                        name="searchProduct"
                        variant="filled"
                        size="small"
                        onChange={(e) => {
                            baseProductSearch(e.target.value);
                        }}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12}>
                    <CustomDataGrid
                        getRowId={row => storeActiveShopHash.cartType === CartDets.Gold ? row.id : row.prdId}
                        rows={productData}
                        columns={storeActiveShopHash.cartType === CartDets.Gold ? columns_gold : columns}
                        mDensity="compact"
                        paginationMode={"server"}
                        paginationModel={paginationModel}
                        onPageDataChange={(e) => baseProductSearch("", e, paginationModel.pageSize)}
                        cbPageSizeChange={(mPageSize) => baseProductSearch("", paginationModel.page, mPageSize)}
                    />
                </Grid>
            </Grid>
        )
    };

    useEffect(() => {
        getCateogoryDetails();
        getConversionData();
        baseProductSearch();
    }, [storeActiveShopHash, storeApiUrl]);

    return (
        <SnpBaseLayout
            loader={loader}
            snackbarConfig={{ ...snackbarConfig, onClose: closeSnackbar }}
            dialogConfig={dialogConfig}
        >
            {renderShowProduct()}
        </SnpBaseLayout>
    )
};

export default ShowProduct;